import Vue, { PropType } from "vue";
import logger from "@/services/loggerService";
import { DeviceConfiguration } from "@/models/deviceConfiguration";
import { WizardConfiguration } from "@/models/wizardConfiguration";

export interface WizardMixin extends Vue {
  onBack: () => void;
  onNext: () => void;
  handleError: (e: unknown) => void;
  first: boolean;
  second: boolean;
  last: boolean;
  index: number;
  steps: string[];
  loading: boolean;
  android: boolean;
  isLegacyWizardFormat: boolean;
  isWizardFeatureEnabled: (
    key: string,
    hideForAndroidLegacy?: boolean
  ) => boolean;
  deviceConfiguration: DeviceConfiguration;
  wizardConfiguration: WizardConfiguration;
}

export default Vue.extend({
  data() {
    return {
      loading: false,
    };
  },
  props: {
    steps: {
      type: Array as PropType<string[]>,
      required: false,
      default: () => [],
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
    deviceConfiguration: {
      type: Object as PropType<DeviceConfiguration>,
    },
    wizardConfiguration: {
      type: Object as PropType<WizardConfiguration>,
      required: false,
    },
  },
  computed: {
    first(): boolean {
      return this.index == 0;
    },
    second(): boolean {
      return this.index == 1;
    },
    last(): boolean {
      return this.index == this.steps.length - 1;
    },
    android(): boolean {
      return this.deviceConfiguration?.deviceType === "AndroidReceiver";
    },
    isLegacyWizardFormat(): boolean {
      return (
        this.deviceConfiguration?.clientConfig?.wizardSetting?.version == null
      );
    },
  },
  methods: {
    isWizardFeatureEnabled(key: string, hideForAndroidLegacy = false): boolean {
      if (this.isLegacyWizardFormat) {
        return hideForAndroidLegacy ? !this.android : true;
      }
      const ws = this.deviceConfiguration?.clientConfig?.wizardSetting;
      return ws[key] != null;
    },
    onBack(): void {
      this.$emit("onPrev");
    },
    onNext() {
      this.$emit("onNext");
    },
    handleError(e: Error): void {
      logger.error(e);
      this.$store.commit(
        "notifications/displayNotification",
        {
          message: e,
          type: "error",
        },
        { root: true }
      );
    },
  },
  watch: {},
});
